import React from "react";
import { withTranslation } from "react-i18next";
import { Card, Button, Label } from "reactstrap";

const AuditLogCardSkeleton: React.FC = ({ t }: any) => {
  return (
    <Card className="shadow p-4 mb-4 border-0 rounded">
      {/* Filters */}
      <div className="mb-4 bg-light px-3 py-3">
        <div className="d-flex justify-content-start align-items-center mb-2 gap-2">
          {/* <h5 className="fw-semibold mb-0">{t("common.table.filters")}</h5> */}
          <div className="placeholder-glow">
            <Button className="btn-label btn-sm disabled placeholder bg-secondary col-2" disabled />
          </div>
        </div>
        <div className="row g-3 d-flex justify-content-between">
          {[1, 2, 3].map((i) => (
            <div key={i} className="col-md-3 placeholder-glow">
              {/* <Label className="form-label text-muted small mb-1">{t("common.table.loading")}</Label> */}
              <div className="form-control placeholder bg-secondary col-12 py-2"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Timeline Skeleton */}
      <div className="timeline-container px-2">
        {[...Array(2)].map((_, logIdx) => (
          <div key={logIdx} className="mb-3">
            {/* Hour Header Placeholder */}
            <div className="d-flex justify-content-between align-items-center bg-light p-2 rounded border placeholder-glow">
              <div className="d-flex align-items-center">
                <i className="ri-time-line text-muted fs-5 me-2"></i>
                <span className="placeholder col-4 bg-secondary rounded"></span>
              </div>
              <div className="d-flex gap-2">
                <span className="placeholder col-3 rounded-pill bg-secondary"></span>
                <span className="placeholder col-3 rounded-pill bg-secondary"></span>
                <span className="placeholder col-3 rounded-pill bg-secondary"></span>
              </div>
            </div>

            {/* Logs Placeholder */}
            <div className="border-start border-2 ps-4 mt-2 position-relative">
              {[...Array(2)].map((_, idx) => (
                <div key={idx} className="position-relative px-2 mb-3 placeholder-glow">
                  {/* Timeline Dot */}
                  <div
                    className="position-absolute start-0 translate-middle bg-secondary border border-white rounded-circle"
                    style={{ width: "12px", height: "12px", top: "12px" }}
                  ></div>

                  <div className="ms-3">
                    {/* Timestamp + Link */}
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="placeholder col-5 bg-secondary"></span>
                      <span className="placeholder col-2 rounded-pill bg-secondary"></span>
                    </div>

                    {/* Metadata */}
                    <div className="placeholder col-8 mb-2 bg-secondary"></div>

                    {/* Details */}
                    <div
                      className="border-start ps-3 placeholder col-12 bg-secondary"
                      style={{ height: "60px" }}
                    ></div>
                  </div>
                  <hr />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default withTranslation()(AuditLogCardSkeleton);
